import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NGXLogger} from 'ngx-logger';
import {BehaviorSubject, Observable} from 'rxjs';
import {PortalMessageBroker} from './portal-message-broker';


export enum WellKnownShellProperties {
  APP_MODE_NORMAL = 'shell:app-mode:normal',
  APP_MODE_POPUP = 'shell:app-mode:popup',
  APP_MODE_WIDGET = 'shell:app-mode:widget',
  EMBEDDED_EMBEDDED = 'shell:embedded:embedded',
  EMBEDDED_EMBEDDING = 'shell:embedded:embedding',
}

export enum WellKnownJustFarmingProperties {
  ANALYTICS = 'vendor:de.just-farming:analytics',
  ERROR_REPORTING = 'vendor:de.just-farming:errorReporting',
}

export type WellKnownProperties = WellKnownShellProperties | WellKnownJustFarmingProperties;
export type PropertyKey = string | WellKnownProperties;

export type Property = boolean | string | number | undefined;
export type ArrayProperty = Property[];
export type ContextInfoProperty = Property | ArrayProperty;

export interface ContextInfo {
  properties: Map<PropertyKey, ContextInfoProperty>;
}


@Injectable({
  providedIn: 'root'
})
export class ContextInfoService {

  private readonly _destroyRef = inject(DestroyRef);

  private readonly _contextInfo$ = new BehaviorSubject<ContextInfo>({
    properties: new Map(),
  });

  constructor(
    private logger: NGXLogger,
    private portalMessageBroker: PortalMessageBroker,
  ) {
    this.portalMessageBroker.registerContextInfoCallback(contextInfo => {
      this._contextInfo$.next(contextInfo);

      this.logger.debug('ContextInfoService: new context info', this._contextInfo$.value);
    });
  }

  get contextInfo(): ContextInfo {
    return this._contextInfo$.value;
  }

  get contextInfo$(): Observable<ContextInfo> {
    return this._contextInfo$.asObservable()
      .pipe(
        takeUntilDestroyed(this._destroyRef),
      );
  }
}
